import React, { useEffect, ReactNode, Fragment } from 'react';

import { captureExceptionWithTags } from './sentry';

type Props = {
  exception?: Error;
  children: ReactNode;
};

export const CaptureSentryException = ({
  exception,
  children,
}: Props): JSX.Element => {
  useEffect(() => {
    if (exception) {
      captureExceptionWithTags(exception, {
        visibleToUser: 'false',
      });
    }
  }, [exception]);

  return <Fragment>{children}</Fragment>;
};
